// ID unique par instance de navigateur/device — utilisé pour le filtrage PubSub
const clientId = typeof crypto?.randomUUID === "function"
	? crypto.randomUUID()
	: Array.from(crypto.getRandomValues(new Uint8Array(16)), b => b.toString(16).padStart(2, "0")).join("");

export default clientId;
